$(document).ready(function(){
  if($('body').hasClass('template-product')){
    $(document).on('click','.four-grid-layout-option .four-product-image-item button.js-photoswipe__zoom',function(){
      var index = $(this).attr('data-index');
      $('[data-product-images] .product__main-photos .product-main-slide').removeClass('is-selected');
      $('[data-product-images] .product__main-photos .product-main-slide[data-index='+index+']').addClass('is-selected');
      $('[data-product-images] .product__main-photos .product-main-slide[data-index='+index+']').find('button.js-photoswipe__zoom').trigger('click')
    });
  }

  $(document).on('click','.js-load-more',function(){
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    $this.find('[load-more-text]').addClass('hide');
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.grid.grid--uniform').append($(responseHTML).find('.grid.grid--uniform').html());
      },
      complete: function() {
        if(currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
          if(currentPage == totalPages){
            $this.hide();
          }
           
        } 
      }
    })
  });
    //drawer remove
  $(document).on('click','#CartDrawer .cart__remove a',function(){
    let arrPdp = [];
    var varId = $(this).attr('data-item-id');
    jQuery.post('/cart/change.js', {quantity: 0, id: varId});
    setTimeout(function() {
           document.dispatchEvent(new CustomEvent('ajaxProduct:added' , {bubbles: true}));
    }, 1500);
  });

  //drawer checkout
  $('#CartDrawer .drawer__footer .form-agreement.cart-check [type="checkbox"]').on('click',function(e){
    if($(this).is(':checked')){
      $(this).css('border','1px solid #959595');
    }
  });
  
  $('#CartDrawer .drawer__footer .cart__checkout-wrapper [name="checkout"]').on('click',function(e){
    if($('#CartDrawer .drawer__footer .form-agreement.cart-check').length > 0){
      var checkbox_length = $('#CartDrawer .drawer__footer .form-agreement.cart-check [type="checkbox"][required]').length;
      var checkbox_checkedlength = $('#CartDrawer .drawer__footer .form-agreement.cart-check [type="checkbox"]:checked').length;

      $('#CartDrawer .drawer__footer .form-agreement.cart-check [type="checkbox"]:not(:checked)').each(function() {
          // Perform actions on each unchecked checkbox
          $(this).css('border','1px solid red');
      });
      $('#CartDrawer .drawer__footer .form-agreement.cart-check [type="checkbox"]:checked').each(function() {
          // Perform actions on each unchecked checkbox
          $(this).css('border','1px solid #959595');
      });
      
      if(checkbox_checkedlength == checkbox_length){
        return true;
      }else{
        e.preventDefault();
      }
    }else{
      $('#CartDrawer .drawer__footer .form-agreement.cart-check [type="checkbox"]').css('border','1px solid #959595');
      return true;
    }
    
  });
});
